import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../Icon";
import { supabase } from "../../supabaseClient";

export default function PartnerSignupForm() {
  const { t } = useTranslation();
  const refForm = useRef(null);

  const [formErrors, setFormErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [formCompleted, setFormCompleted] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    company_name: "",
    company_type: "",
    country: "",
    city: "",
    kvk_number: "",
    email: "",
    phone: "",
    website: "",
    instagram: "",
    tiktok: "",
  });

  const validateName = (name) => {
    return name.length > 0;
  };

  const validateEmail = (email) => {
    return email.length > 0 && email.includes("@");
  };

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!validateName(formData.first_name)) {
      errors.first_name = true;
      isValid = false;
    }

    if (!validateName(formData.last_name)) {
      errors.last_name = true;
      isValid = false;
    }

    if (!validateName(formData.company_name)) {
      errors.company_name = true;
      isValid = false;
    }

    if (!validateName(formData.kvk_number)) {
      errors.kvk_number = true;
      isValid = false;
    }

    if (!validateName(formData.country)) {
      errors.country = true;
      isValid = false;
    }

    if (!validateName(formData.city)) {
      errors.city = true;
      isValid = false;
    }

    if (!validateEmail(formData.email)) {
      errors.email = true;
      isValid = false;
    }

    setFormErrors(errors);

    // Check if any of the errors are true
    const hasErrors = Object.values(errors).some((error) => error);
    if (hasErrors) {
      if (refForm.current) {
        refForm.current?.scrollIntoView({ behavior: "smooth" });
      }
    }

    return isValid;
  };

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e, isScroll = false) => {
    setBtnDisabled(true);
    e.preventDefault();

    if (isScroll) {
      refForm.current?.scrollIntoView({ behavior: "smooth" });
    }

    if (validateForm()) {
      console.log("formData:", formData);

      const { data, error } = await supabase.from("PartnerSignUp").insert({
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        company_name: formData.company_name,
        company_type: formData.company_type,
        country: formData.country,
        city: formData.city,
        kvk_number: formData.kvk_number,
        phone: formData.phone,
        website: formData.website,
        instagram: formData.instagram,
        tiktok: formData.tiktok,
      });

      if (error) {
        console.error("Error inserting event signup:", error);
        setBtnDisabled(false);
        return;
      }

      setBtnDisabled(false);
      setFormCompleted(true);
    }
    setBtnDisabled(false);
  };

  return (
    <div className="bg-white mx-auto max-md:mt-[24px] md:mt-[48px] p-[32px_24px] rounded-[8px] w-full max-w-[500px] partner-signup-form">
      <div className="" ref={refForm}>
        <h3 className="text-white form-heading">{t("your_details")}</h3>
        <form className="space-y-[16px] mt-[16px] partner-form">
          <div className="gap-4 grid grid-cols-2">
            <input
              type="text"
              placeholder={t("first_name")}
              name="first_name"
              value={formData.first_name}
              className={formErrors.first_name ? "sin error-field" : "sin"}
              onChange={onChange}
            />
            <input
              type="text"
              placeholder={t("last_name")}
              name="last_name"
              value={formData.last_name}
              className={formErrors.last_name ? "sin error-field" : "sin"}
              onChange={onChange}
            />
          </div>

          <input
            type="text"
            name="company_name"
            id="company_name"
            value={formData.company_name}
            placeholder={t("company_name")}
            className={formErrors.company_name ? "sin error-field" : "sin"}
            onChange={onChange}
          />

          <select
            className={` sin ${formErrors.company_type ? "error-field" : ""}`}
            name="company_type"
            size="1"
            data-filter="false"
            data-placeholder=""
            onChange={onChange}
          >
            <option value="company_type" disabled selected>
              {t("company_type")}
            </option>
            <option value="Club">Club</option>
            <option value="Festival">Festival</option>
            <option value="Restaurant">Restaurant</option>
            <option value="Lifestyle brand">Lifestyle brand</option>
            <option value="Other">Other</option>
          </select>

          <input
            type="text"
            name="kvk_number"
            id="kvk_number"
            value={formData.kvk_number}
            placeholder={t("kvk_number")}
            className={formErrors.kvk_number ? "sin error-field" : "sin"}
            onChange={onChange}
          />

          <select
            className={`sin ${formErrors.company_type ? "error-field" : ""}`}
            name="country"
            size="1"
            data-filter="false"
            data-placeholder=""
            onChange={onChange}
          >
            <option value="country" disabled selected>
              Land
            </option>
            <option value="Nederland">Netherlands</option>
            <option value="United Kingdom">United Kingdom</option>
            <option value="Spain">Spain</option>
            <option value="Bali">Bali</option>
            <option value="Other">Other</option>
          </select>

          <select
            className={`sin ${formErrors.company_type ? "error-field" : ""}`}
            name="city"
            size="1"
            data-filter="false"
            data-placeholder=""
            onChange={onChange}
          >
            <option value="city" disabled selected>
              Stad
            </option>
            <option value="Amsterdam">Amsterdam</option>
            <option value="Rotterdam">Rotterdam</option>
            <option value="Den Haag">Den Haag</option>
            <option value="Leiden">Leiden</option>
            <option value="Scheveningen">Scheveningen</option>
            <option value="Bloemendaal">Bloemendaal</option>
            <option value="Utrecht">Utrecht</option>
            <option value="Bali">Bali</option>
            <option value="London">London</option>
            <option value="Ibiza">Ibiza</option>
            <option value="Barcalona">Barcalona</option>
            <option value="Other">Other</option>
          </select>

          <input
            type="email"
            name="email"
            id="email"
            value={formData.email}
            placeholder={t("email")}
            className={formErrors.email ? "sin error-field" : "sin"}
            onChange={onChange}
          />

          <input
            type="text"
            name="phone"
            id="phone"
            value={formData.phone}
            placeholder={t("phone")}
            className={formErrors.phone ? "sin error-field" : "sin"}
            onChange={onChange}
          />

          <input
            type="url"
            name="website"
            id="website"
            value={formData.website}
            placeholder={t("website")}
            className={formErrors.website ? "sin error-field" : "sin"}
            onChange={onChange}
          />

          <input
            type="text"
            name="instagram"
            id="instagram"
            value={formData.instagram}
            placeholder={t("instagram_handle")}
            className={formErrors.instagram ? "sin error-field" : "sin"}
            onChange={onChange}
          />

          <input
            type="text"
            name="tiktok"
            id="tiktok"
            value={formData.tiktok}
            placeholder={t("tiktok_handle")}
            className={formErrors.tiktok ? "sin error-field" : "sin"}
            onChange={onChange}
          />

          <div
            className={`flex items-center w-full gap-[12px] ${
              formErrors.agreement ? "error-field" : ""
            }`}
          >
            <input
              type="checkbox"
              id="agreement"
              name="agreement"
              onChange={onChange}
            />
            <div className="mt-1 text-[#D4D2D9] text-[14px] leading-[20px]">
              {t("i_agree_to_the")}{" "}
              <a
                href="https://22night.com/terms"
                target="_blank"
                rel="noreferrer"
                className="text-[#999BEC] text-[14px] hover:underline leading-[20px]"
              >
                {t("terms_and_conditions")}
              </a>
            </div>
          </div>

          <button
            className={`flex items-center justify-center text-white rounded-[6px] border-[1.5px] !mt-[32px] w-full text-[16px] font-semibold p-[16px_12px] premium-button disabled:opacity-50 disabled:cursor-not-allowed`}
            type="button"
            onClick={handleSubmit}
            disabled={btnDisabled || formCompleted}
          >
            {formCompleted ? (
              <div className="flex items-center gap-2">
                <Icon
                  icon="mdi:check"
                  className="w-[20px] h-[20px] text-white"
                />
                Bedankt!
              </div>
            ) : (
              "Meld je aan"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
